var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28033 13.5303C6.98744 13.8232 6.51256 13.8232 6.21967 13.5303L0.21967 7.53033C-0.0732231 7.23744 -0.0732231 6.76256 0.21967 6.46967L6.21967 0.46967C6.51256 0.176777 6.98744 0.176777 7.28033 0.46967C7.57322 0.762563 7.57322 1.23744 7.28033 1.53033L1.81066 7L7.28033 12.4697C7.57322 12.7626 7.57322 13.2374 7.28033 13.5303Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.c03d0a7c95fa67c641ab6717d8ad87fc.svg";
export { ForwardRef as ReactComponent };